<template>
  <v-img
    :aspect-ratio="16/9" 
    :src="image" 
    class="mb-4" 
    cover 
    max-height="600"
    max-width="1200" 
    v-if="image" 
  >
    <v-container class="d-flex fill-height justify-end align-end pa-0" v-if="caption">
      <v-card flat class="d-flex align-end" style="background-color:rgba(0,0,0,0.5);">
        <v-card-text class="white--text caption py-2" v-html="caption"></v-card-text>
      </v-card>
    </v-container>
  </v-img>
</template>

<script>
  export default {
    name: 'PostFeaturedImage',

    props: ['image', 'caption']
  }
</script>